import {
    AggregatedOpenSubmissions,
    useAggregatedOpenSubmissions,
} from 'widgets/openSubmissions/hooks';
import { OpenSubmissionsStreamItem } from 'widgets/openSubmissions/store/stream/OpenSubmissionsStreamDataState';
import { useContext } from 'react';
import AppContext from 'app/AppContext';

export interface OpenSubmissionsChartData {
    aggregatedOpenSubmissionsData: AggregatedOpenSubmissions;
    notConditionalLabel: string;
    conditionalLabel: string;
}

export function useOpenSubmissionsChartData(
    items: OpenSubmissionsStreamItem[]
): OpenSubmissionsChartData {
    const { numberFormat } = useContext(AppContext);
    const aggregatedOpenSubmissionsData = useAggregatedOpenSubmissions(items);

    const notConditionalLabel = `${numberFormat.n0(
        aggregatedOpenSubmissionsData.notConditional
    )} working`;
    const conditionalLabel = `${numberFormat.n0(
        aggregatedOpenSubmissionsData.conditional
    )} conditional`;

    return {
        aggregatedOpenSubmissionsData,
        notConditionalLabel,
        conditionalLabel,
    };
}
